;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { AlertDescription, Alert as UIAlert } from '@workspace/ui/components/alert';
import { cn } from '@workspace/ui/lib';
import { CircleAlert, CircleCheck, CircleMinus, Info } from 'lucide-react';
import type { ReactNode } from 'react';

type AlertVariant = 'info' | 'info-pink' | 'error' | 'warning' | 'success' | 'warning-gradient';

const iconStyle = 'md:w-4 md:h-4';

const variantIcon: Record<Exclude<AlertVariant, 'warning-gradient'>, ReactNode> = {
  info: (
    <Info
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-blue-600 dark:text-blue-400')}
    />
  ),
  'info-pink': <Info className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-pink-400')} />,
  error: (
    <CircleMinus
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-red-500 dark:text-red-400')}
    />
  ),
  warning: (
    <CircleAlert
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-orange-600 dark:text-orange-400')}
    />
  ),
  success: (
    <CircleCheck
      className={cn(iconStyle, 'h-4! w-4! min-w-4! stroke-2! text-green-500 dark:text-green-400')}
    />
  ),
};

interface AlertProps {
  description?: string | ReactNode;
  title?: string | ReactNode;
  variant?: AlertVariant;
  className?: string;
  descriptionClassName?: string;
  button?: ReactNode;
}

export function Alert({
  description,
  title,
  variant = 'info',
  className,
  descriptionClassName,
  button,
}: AlertProps) {
  if (variant === 'warning-gradient') {
    return (
      <UIAlert
        className={cn(
          'xs:flex-row flex-col items-end justify-between gap-4 overflow-clip rounded-3xl border border-yellow-400 px-7 py-9 shadow-sm',
          'bg-[linear-gradient(134deg,#fff_20%,#fbf2e3_60%)] dark:border-yellow-200 dark:bg-[linear-gradient(134deg,var(--grey-1000),var(--grey-1000))]',
          className
        )}
      >
        <div className="flex shrink-0 flex-col items-start gap-3">
          {title &&
            (typeof title === 'string' ? (
              <p className="text-xl font-bold text-neutral-200 dark:text-grey-200">{title}</p>
            ) : (
              title
            ))}
          {description &&
            (typeof description === 'string' ? (
              <p
                className={cn(
                  'text-base text-neutral-200 dark:text-grey-200',
                  descriptionClassName
                )}
              >
                {description}
              </p>
            ) : (
              description
            ))}
        </div>
        {button && <div className="xs:w-auto w-full shrink-0">{button}</div>}
      </UIAlert>
    );
  }

  const icon = variantIcon[variant];

  return (
    <UIAlert className={cn(className, 'xs:items-center xs:flex-row flex-col items-start')}>
      <AlertDescription
        className={cn('flex w-full !items-start justify-start gap-2', descriptionClassName)}
      >
        <div className="flex size-5 items-center justify-center">{icon}</div>
        {description}
      </AlertDescription>
      {button && <div className="xs:ml-auto xs:w-auto ml-0 w-full">{button}</div>}
    </UIAlert>
  );
}
